import { useEffect } from 'react';

const INACTIVITY_LIMIT = 20 * 60 * 1000; // 20 minutos em ms

function useAutoLogout() {
  useEffect(() => {
    let timeout;
    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        localStorage.removeItem('token');
        localStorage.setItem('logoutReason', 'inatividade');
        window.location.href = '/login';
      }, INACTIVITY_LIMIT);
    };

    // Eventos que contam como atividade (removido 'mousemove')
    const events = ['keydown', 'mousedown', 'touchstart'];
    events.forEach(event => window.addEventListener(event, resetTimer));

    resetTimer(); // Inicializa o timer

    return () => {
      clearTimeout(timeout);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, []);
}

export default useAutoLogout; 